"use strict";var a;exports.DaysOfWeek=void 0,(a=exports.DaysOfWeek||(exports.DaysOfWeek={}))[a.Sunday=0]="Sunday",a[a.Monday=1]="Monday",a[a.Tuesday=2]="Tuesday",a[a.Wednesday=3]="Wednesday",a[a.Thursday=4]="Thursday",a[a.Friday=5]="Friday",a[a.Saturday=6]="Saturday";
//# sourceMappingURL=week-days.enum.js.map
